import React, { useState } from 'react';
import { Row, Col, Card, Select, Spin, Tooltip } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import {
  CardTitleText,
  MenuItemText,
  TableColumnTitle,
} from '../../../../../../../shared/globalStyling/styledText';
import TransactionCreativeTable from './TransactionCreativesTable';
import { colors } from '../../../../../../../../core/utils/constants/listOfColors';
import TransactionCreativeRingChart from './TransactionCreativeRingChart';

const Style = {
  campaignCardStyle: {
    margin: 5,
    padding: 2,
    height: 340,
    backgroundColor: '#fff',
  },
  campaignCardStyleCreatives: {
    backgroundColor: '#fff',
  },
  keyColors: {
    spent: '#1665d8',
    remaining: '#34aa44',
    budget: '#030303',
    total: '#bec0c3',
    value: '#99999',
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  xs: {
    span: 24,
    offset: 0,
  },
  sm: {
    span: 24,
    offset: 0,
  },
  md: {
    span: 16,
    offset: 0,
  },
  lg: {
    span: 16,
    offset: 0,
  },
  xl: {
    span: 16,
    offset: 0,
  },
  xsPie: {
    span: 24,
    offset: 0,
  },
  smPie: {
    span: 24,
    offset: 0,
  },
  mdPie: {
    span: 8,
    offset: 0,
  },
  lgPie: {
    span: 8,
    offset: 0,
  },
  xlPie: {
    span: 8,
    offset: 0,
  },
};

const {
  xs,
  sm,
  md,
  lg,
  xl,
  xsPie,
  smPie,
  mdPie,
  lgPie,
  xlPie,
  campaignCardStyleCreatives,
  campaignCardStyle,
} = Style;

const Extra = ({ setCreativeDimension }) => {
  const options = [
    {
      value: 'impressions',
      text: 'Impressions',
    },
    {
      value: 'totalTransactions',
      text: 'Transactions',
    },
  ];
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-between', gap: '4px' }}>
      <div style={{ whiteSpace: 'nowrap' }}>
        <CardTitleText text={'Breakdown'} />
      </div>
      <div style={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', minWidth: 0, gap: '4px' }}>
        <span style={{ whiteSpace: 'nowrap' }}>
          <TableColumnTitle text={'Show By:'} />
        </span>
        <Select
          style={{ minWidth: '80px', maxWidth: '140px' }}
          defaultValue={options[0].value}
          onChange={(value) => {
            setCreativeDimension(value);
          }}
        >
          {options.map((option, index) => {
            return (
              <Option key={index} value={option.value}>
                <MenuItemText text={option.text} />
              </Option>
            );
          })}
        </Select>
      </div>
    </div>
  );
};

const TransactionCreativeDetails = ({ creatives = [], loading = false, byDateLoading = false }) => {
  const [creativeDimension, setCreativeDimension] = useState('impressions');

  // Sort by impression count (descending)
  const sortedCreatives = [...creatives].sort((a, b) => (b.impressions || 0) - (a.impressions || 0));

  // Assign colors and value field to each creative based on their index
  const creativesWithColors = sortedCreatives.map((creative, index) => ({
    ...creative,
    color: colors[index % colors.length],
    value: creative.name || creative.media || `creative-${index}`,
    totalTransactions: creative.transactions,
  }));

  // Custom title with loading indicator
  const CreativesTitle = () => (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
      <CardTitleText text={'Creatives'} />
      {byDateLoading && (
        <Tooltip title="Loading by-date data for filtering. Date range filters will be available once complete.">
          <Spin indicator={<LoadingOutlined style={{ fontSize: 16 }} spin />} />
        </Tooltip>
      )}
    </div>
  );

  return (
    <Row gutter={35}>
      <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl}>
        <Card
          style={campaignCardStyleCreatives}
          headStyle={{ borderWidth: '3px', height: '66px' }}
          bodyStyle={{ padding: 0 }}
          title={<CreativesTitle />}
        >
          <TransactionCreativeTable creativeData={creativesWithColors} />
        </Card>
      </Col>
      <Col xs={xsPie} sm={smPie} md={mdPie} lg={lgPie} xl={xlPie}>
        <Card
          style={campaignCardStyleCreatives}
          bodyStyle={{ padding: 0, height: '100%' }}
          headStyle={{ borderWidth: '2px', minHeight: '66px', height: 'auto' }}
          title={<Extra setCreativeDimension={setCreativeDimension} />}
        >
          <TransactionCreativeRingChart
            data={creativesWithColors}
            height={campaignCardStyle.height}
            selectedCreativeDimension={creativeDimension}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default TransactionCreativeDetails;
